module.exports = __webpack_public_path__ + "static/media/bg-cody-chan.fb2f271a.jpg";